import React from "react";
import ActivityListTemplate from "../components/ActivityListTemplate.tsx";
import { useTranslation } from "react-i18next";

export default function FutureActivity() {
  const { t } = useTranslation();

  return <ActivityListTemplate type="FUTURE_ACTIVITY" title={t("future")} />;
}
